module.exports = __webpack_public_path__ + "assets/img/18_1870.c8def78e.jpg";